import {COLORS,FONTS} from '../../coldcompute/theme';

export type Word = {word:string;start:number;end:number};
export type Caption = {text:string;start:number;end:number};
export type Beat = {
  id:string;chapter:number;scene:string;tone:string;text:string;cue:string;
  start:number;audioEnd:number;end:number;cueTime:number;pauseSeconds:number;
  captions:Caption[];words:Word[];
};
export type LessonTiming = {
  title:string;fps:number;width:number;height:number;duration:number;
  durationFrames:number;provisional:boolean;scenes:Beat[];
  chapters:{title:string;start:number;index:number}[];
};

export const C=COLORS;
export const FONT=FONTS.body;
export const clamp=(v:number)=>Math.min(1,Math.max(0,v));
export const norm=(s:string)=>s.toLowerCase().replace(/[^a-z0-9]/g,'');

export const wordTime=(beat:Beat,phrase:string):number=>{
  const needle=norm(phrase),tokens=beat.words.map(w=>norm(w.word));
  for(let i=0;i<tokens.length;i++){
    let candidate='';
    for(let j=i;j<tokens.length;j++){
      candidate+=tokens[j];
      if(candidate===needle)return beat.words[i].start;
      if(candidate.length>=needle.length)break;
    }
  }
  if(beat.words.length===0)return beat.cueTime; // Explicit provisional storyboard only.
  throw new Error(`Missing actual narration cue: ${beat.id}: ${phrase}`);
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
